'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondsAfter.js
// module id = 735
// module chunks = 0